/*
 * Maison Alia — KIDS configurator CONTROLLER (presentation only).
 * Renders the Adult "tac-bedcfg" presentation shell, but is driven ENTIRELY by
 * the Kids business/state engine (window.TACKids). No Adult business logic,
 * component ids, sizes, pricing or state rules are used here — only Adult's
 * visual structure/classes are reproduced. Cart plumbing is delegated to
 * TACBundleCore via TACKids.cartItems (single source of truth).
 */
(function () {
  'use strict';
  var Core = window.TACBundleCore, K = window.TACKids;
  var root = document.querySelector('[data-tac-bedcfg][data-tac-kids]');
  if (!root || !Core || !K || root.dataset.tacReady) return;
  root.dataset.tacReady = '1';

  var byId;
  try { byId = JSON.parse(root.querySelector('[data-tac-kids-catalog]').textContent); }
  catch (e) { return; }

  var TIER = (root.getAttribute('data-tier') || 'standard').toLowerCase();
  var TL = K.TIER_LABEL[TIER] || 'Standard';   // internal tier (Standard/Light/Heavy) — variant resolution ONLY; the embroidery expression is described once in the Product Description and never repeated in the configurator UI
  var CTX = {
    set: root.getAttribute('data-set') || '',
    collection: root.getAttribute('data-collection') || '',
    embroidery: root.getAttribute('data-embroidery') || root.getAttribute('data-collection') || '',
    bundleHandle: root.getAttribute('data-bundle-handle') || '',
    displayTitle: root.getAttribute('data-title') || (root.getAttribute('data-set') || '') + ' Bed Set',
    leadTime: root.getAttribute('data-leadtime') || '4–6 weeks'
  };

  var state = K.initState({ mattress: 'infant-60x120', fabric: 'cotton', tier: TIER });
  // Per-row open/closed UI state (presentation only; not part of business state).
  var ui = { fitted: false, duvet: false, sleeping: false, flat: false, square: false };

  // ---- helpers ----
  function fabricLabel() { return K.FABRIC_LABEL[state.fabric]; }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function money(euros) {
    return Number(euros).toLocaleString('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function meas(sz) { return Core.formatMeasure(sz); }
  // price of a component line (euros) via the Kids catalog (single source of truth)
  function px(component, size, tiered, depth) {
    var v = Core.findVariant(byId[component], { fabric: fabricLabel(), size: size, opt3: tiered ? TL : depth });
    return v ? v.price : 0;
  }
  // distinct real sizes for a component, in catalog order (single source of truth)
  function sizesOf(component) {
    var seen = {}, out = [], cat = byId[component] || {};
    Object.keys(cat).forEach(function (id) { var s = cat[id].size; if (s && !seen[s]) { seen[s] = 1; out.push(s); } });
    return out;
  }
  function dispatch(a) { state = K.reduce(state, a); render(); }

  var elFabricOpts = root.querySelector('[data-tac-fabric-opts]');
  var elRows = root.querySelector('[data-tac-rows]');
  var elSummary = root.querySelector('[data-tac-summary]');
  var elAtc = root.querySelector('[data-tac-atc]');
  var elAtcLabel = root.querySelector('[data-tac-atc-label]');
  var elLead = root.querySelector('[data-tac-lead]');
  var elEmpty = root.querySelector('[data-tac-empty]');

  // ---- fabric ----
  function renderFabric() {
    elFabricOpts.innerHTML = [['cotton', 'ALIA Cotton Sateen'], ['signature', 'ALIA Signature']].map(function (f) {
      return '<button type="button" class="tac-bedcfg__fab" data-fab="' + f[0] + '" aria-pressed="' + (state.fabric === f[0]) + '">' + esc(f[1]) + '</button>';
    }).join('');
  }

  // ---- option pill helpers (Adult .tac-opt look) ----
  function opt(dataAttr, value, label, pressed, delta) {
    var d = (delta != null && delta !== 0) ? '<span class="tac-opt__delta">' + (delta > 0 ? '+' : '') + money(Math.abs(delta)).replace(/ ?€/, ' €').replace('-', '') + '</span>' : '';
    // delta already signed via prefix; show signed short euro
    return '<button type="button" class="tac-opt" ' + dataAttr + '="' + esc(value) + '" aria-pressed="' + (!!pressed) + '">' + esc(label) + d + '</button>';
  }
  function deltaTag(delta) {
    if (!delta) return '';
    var s = (delta > 0 ? '+' : '−') + money(Math.abs(delta));
    return '<span class="tac-opt__delta">' + s + '</span>';
  }
  function pill(dataAttr, value, label, pressed, delta) {
    return '<button type="button" class="tac-opt" ' + dataAttr + '="' + esc(value) + '" aria-pressed="' + (!!pressed) + '">' + esc(label) + deltaTag(delta) + '</button>';
  }
  // Absolute add-on price tag — used for OPTIONAL components (not in the curated base
  // composition), where a customer must see the full price the item adds, not a delta
  // against an invisible reference. Reads the real variant price (euros).
  function priceTag(euros) {
    return '<span class="tac-opt__delta tac-opt__abs">+' + money(euros) + '</span>';
  }
  function pillAbs(dataAttr, value, label, pressed, euros) {
    return '<button type="button" class="tac-opt" ' + dataAttr + '="' + esc(value) + '" aria-pressed="' + (!!pressed) + '">' + esc(label) + priceTag(euros) + '</button>';
  }
  function qtyCtl(key, val, min) {
    return '<div class="tac-qty" data-qty="' + key + '"><button type="button" data-dir="-1"' + (val <= min ? ' disabled' : '') + '>&minus;</button><span>' + val + '</span><button type="button" data-dir="1">+</button></div>';
  }

  // ---- row summaries (collapsed state) ----
  var m = function () { return K.MATTRESS[state.mattress]; };

  function fittedSummary() {
    return meas(m().fitted) + ' · ' + state.depth.replace('Up to ', '') + ' · Qty 1';
  }
  function duvetSummary() { return meas(state.duvet.size) + ' · Qty 1'; }
  function sleepingSummary() {
    return state.sleeping.lines.map(function (l) { return meas(l.size) + ' · Qty ' + l.qty; }).join('<br>');
  }
  function flatSummary() { return state.flat.active && state.flat.size ? meas(state.flat.size) + ' · Qty 1' : 'Not included'; }
  function squareSummary() {
    if (!state.square.lines.length) return 'Not included';
    return state.square.lines.map(function (l) { return meas(l.size) + ' · Qty ' + l.qty; }).join('<br>');
  }

  // ---- row panels ----
  // ---- Bed Size premium dropdown helpers (Kids). Name/dimensions are DERIVED from
  // the EXISTING mattress data (K.MATTRESS[k].label + meas()); no new size data. ----
  function mattressParts(k) {
    var label = K.MATTRESS[k].label;
    var bits = label.split(' · ');
    var name = bits[0];
    var cm = bits.length > 1 ? bits.slice(1).join(' · ') : label;
    var measured = meas(cm);
    var inch = '';
    var mm = measured.match(/\(([^)]+)\)/);
    if (mm) inch = mm[1];
    return { name: name, cm: cm, inch: inch };
  }
  function bedSizeSelect() {
    var cur = mattressParts(state.mattress);
    var h = '<div class="tac-mselect" data-tac-mselect>';
    h += '<button type="button" class="tac-mselect__field" data-mselect-toggle aria-haspopup="listbox" aria-expanded="false" aria-labelledby="tac-bedsize-label tac-mselect-value">';
    h += '<span class="tac-mselect__value" id="tac-mselect-value"><span class="tac-mselect__name">' + esc(cur.name + ' · ' + cur.cm) + '</span><span class="tac-mselect__dim">' + esc(cur.inch) + '</span></span>';
    h += '<span class="tac-mselect__chev" aria-hidden="true"></span></button>';
    h += '<div class="tac-mselect__panel" data-mselect-panel role="listbox" aria-labelledby="tac-bedsize-label" tabindex="-1" hidden>';
    var lastName = null;
    Object.keys(K.MATTRESS).forEach(function (k) {
      var p = mattressParts(k);
      if (p.name !== lastName) {
        if (lastName !== null) h += '</div>';
        h += '<div class="tac-mselect__group" role="group" aria-label="' + esc(p.name) + '"><div class="tac-mselect__grouplabel">' + esc(p.name) + '</div>';
        lastName = p.name;
      }
      var sel = state.mattress === k;
      h += '<div class="tac-mselect__opt" role="option" data-mselect-opt="' + esc(k) + '" aria-selected="' + (sel ? 'true' : 'false') + '" tabindex="' + (sel ? '0' : '-1') + '">';
      h += '<span class="tac-mselect__opt-text"><span class="tac-mselect__opt-dim">' + esc(p.cm) + '</span><span class="tac-mselect__opt-in">' + esc(p.inch) + '</span></span>';
      h += '<span class="tac-mselect__opt-check" aria-hidden="true">&#10003;</span></div>';
    });
    if (lastName !== null) h += '</div>';
    h += '</div></div>';
    return h;
  }

  function fittedPanel() {
    var h = '';
    // Bed size (mattress) — drives fitted/duvet/sham sizing
    h += '<div class="tac-field"><div class="tac-field__label" id="tac-bedsize-label">Bed Size</div><div class="tac-field__hint">Children’s mattress sizes vary. Please select your child’s exact mattress dimensions.</div>';
    h += bedSizeSelect();
    h += '</div>';
    // Depth
    var baseFit = px('fitted', m().fitted, false, K.DEPTHS[0]);
    h += '<div class="tac-field"><div class="tac-field__label">Mattress Depth</div><div class="tac-field__hint">Please select the depth that corresponds to the thickness of your mattress.</div><div class="tac-opts">';
    h += K.DEPTHS.map(function (d) {
      var delta = px('fitted', m().fitted, false, d) - baseFit;
      return pill('data-depth', d, d.replace('Up to ', ''), state.depth === d, delta);
    }).join('');
    h += '</div></div>';
    return h;
  }

  function sleepingPanel() {
    var h = '';
    state.sleeping.lines.forEach(function (l, i) {
      var base = px('rect', l.size, true);
      h += '<div class="tac-shamline" data-sham-line="' + i + '"><div style="flex:1 1 60%"><div class="tac-field__label" style="margin-bottom:6px">Size</div><div class="tac-opts" data-line="' + i + '">';
      h += K.SHAM_SIZES.map(function (sz) {
        return pill('data-sleeping-size', sz, meas(sz), l.size === sz, px('rect', sz, true) - base);
      }).join('');
      h += '</div></div><div>' + qtyCtl('sleeping:' + i, l.qty, 1) + (state.sleeping.lines.length > 1 ? '<br><button type="button" class="tac-linkbtn tac-linkbtn--remove" data-sleeping-remove="' + i + '" style="margin-top:8px">Remove size</button>' : '') + '</div></div>';
    });
    if (K.sleepingCanAddMore(state)) h += '<button type="button" class="tac-linkbtn" data-sleeping-add="1" style="margin-top:6px">+ Add another pillow size</button>';
    return h;
  }

  function flatPanel() {
    var sizes = ['120 × 180 cm', '130 × 200 cm', '170 × 290 cm', '180 × 290 cm'];
    var rec = m().flat;
    var h = '';
    if (state.flat.overridden && state.flat.size !== rec) {
      h += '<div class="tac-reco">Recommended for this bed: ' + esc(meas(rec)) + '<button type="button" data-flat-apply="1">Apply</button></div>';
    }
    h += '<div class="tac-field"><div class="tac-field__label">Flat Sheet Size</div><div class="tac-opts">';
    // Flat Sheet is an OPTIONAL add-on → show the full absolute price per size.
    h += sizes.map(function (sz) { return pillAbs('data-flat-size', sz, meas(sz), state.flat.size === sz, px('flat', sz, true)); }).join('');
    h += '</div></div>';
    h += '<button type="button" class="tac-linkbtn tac-linkbtn--remove tac-row__remove" data-flat-remove="1">Remove from set</button>';
    return h;
  }

  function duvetPanel() {
    var rec = m().duvet;
    var h = '';
    // Maison Alia recommends; the customer decides. Reco banner only when the
    // chosen size differs from the mattress recommendation (mirrors Adult Bed).
    if (state.duvet.size !== rec) {
      h += '<div class="tac-reco">Recommended Duvet Cover size: ' + esc(meas(rec)) + '<button type="button" data-duvet-apply="1">Apply</button></div>';
    }
    var base = px('duvet', rec, true);
    h += '<div class="tac-field"><div class="tac-field__label">Duvet Cover Size</div><div class="tac-opts">';
    // Duvet Cover is an INCLUDED component → alternative sizes show real +/- deltas.
    h += sizesOf('duvet').map(function (sz) { return pill('data-duvet-size', sz, meas(sz), state.duvet.size === sz, px('duvet', sz, true) - base); }).join('');
    h += '</div></div>';
    return h;
  }

  function squarePanel() {
    var h = '';
    state.square.lines.forEach(function (l, i) {
      h += '<div class="tac-shamline" data-sq-line="' + i + '"><div style="flex:1 1 60%"><div class="tac-field__label" style="margin-bottom:6px">Size</div><div class="tac-opts" data-line="' + i + '">';
      // Square Pillow Shams are an OPTIONAL add-on → show the full absolute price per size.
      h += K.SQUARE_SIZES.map(function (sz) { return pillAbs('data-square-size', sz, meas(sz), l.size === sz, px('square', sz, true)); }).join('');
      h += '</div></div><div>' + qtyCtl('square:' + i, l.qty, 1) + '<br><button type="button" class="tac-linkbtn tac-linkbtn--remove" data-square-remove="' + i + '" style="margin-top:8px">Remove size</button></div></div>';
    });
    return h;
  }

  // ---- personalization card (Kids-specific, styled in Adult language) ----
  function persoBlock() {
    var pv = K.validatePersonalization(state.personalization);
    var h = '<div class="tac-row tac-row--perso" data-comp="perso"><div class="tac-row__head"><div>' +
      '<p class="tac-row__name">Personalized Pillow Sham</p>' +
      '<p class="tac-row__summary">' + esc(meas(m().sham)) + ' · always included</p></div>' +
      '<span class="tac-row__badge">Complimentary</span></div>' +
      '<div class="tac-row__perso"><label class="tac-field__label" for="tac-perso" style="font-size:14px">Child’s name or initials (optional)</label>' +
      '<input id="tac-perso" class="tac-perso-input" type="text" maxlength="16" autocomplete="off" spellcheck="false" data-perso value="' + esc(state.personalization) + '">' +
      (pv.ok ? '' : '<p class="tac-perso-err">' + esc(persoMsg(pv.reason)) + '</p>') +
      '</div></div>';
    return h;
  }
  function persoMsg(r) {
    return r === 'too-long' ? 'Please use 16 characters or fewer.'
      : r === 'no-digits' ? 'Letters, spaces, apostrophes, hyphens and periods only — no numbers.'
      : r === 'invalid-char' ? 'Please use letters only (accents allowed).'
      : 'Please use a single line of letters.';
  }

  // ---- rows ----
  function row(key, name, summaryHtml, isNone, action, open, panelHtml) {
    var actBtn = action ? '<button type="button" class="tac-row__action" data-toggle="' + key + '">' + action + '</button>' : '';
    var sumCls = isNone ? 'tac-row__summary tac-row__summary--none' : 'tac-row__summary';
    var panel = open ? '<div class="tac-row__panel" data-panel="' + key + '">' + panelHtml + '</div>' : '';
    return '<div class="tac-row" data-comp="' + key + '"><div class="tac-row__head"><div><p class="tac-row__name">' + name + '</p><p class="' + sumCls + '">' + summaryHtml + '</p></div>' + actBtn + '</div>' + panel + '</div>';
  }

  function renderRows() {
    var h = '';
    // Fitted (Bed size + depth live here, Adult-style)
    h += row('fitted', 'Fitted Sheet', fittedSummary(), false, ui.fitted ? 'Close' : 'Edit', ui.fitted, fittedPanel());
    // Duvet (recommended from bed size; customer may choose any size — Adult-style)
    h += row('duvet', 'Duvet Cover', duvetSummary(), false, ui.duvet ? 'Close' : 'Edit', ui.duvet, duvetPanel());
    // Sleeping shams
    h += row('sleeping', 'Sleeping Pillow Sham', sleepingSummary(), false, ui.sleeping ? 'Close' : 'Edit', ui.sleeping, sleepingPanel());
    // Personalized sham (genuine €0)
    h += persoBlock();
    // Flat (optional)
    if (state.flat.active) h += row('flat', 'Flat Sheet', flatSummary(), false, ui.flat ? 'Close' : 'Edit', ui.flat, flatPanel());
    else h += row('flat', 'Flat Sheet', 'Not included', true, '+ Add', false, '');
    // Square (optional)
    if (state.square.lines.length) h += row('square', 'Square Pillow Shams', squareSummary(), false, ui.square ? 'Close' : 'Edit', ui.square, squarePanel());
    else h += row('square', 'Square Pillow Shams', 'Not included', true, '+ Add', false, '');
    elRows.innerHTML = h;
  }

  // ---- summary (Adult grouped structure) ----
  function renderSummary() {
    var pv = K.validatePersonalization(state.personalization);
    var g = '';
    g += '<h4 class="tac-sum__title">Your ' + esc(CTX.displayTitle) + '</h4>';
    g += '<div class="tac-sum__group"><div class="tac-sum__gk">Fabric</div><div class="tac-sum__line"><span>' + esc(fabricLabel()) + '</span><span></span></div></div>';
    // Bed linen: fitted, flat, duvet
    var linen = '';
    linen += '<div class="tac-sum__line"><span>Fitted Sheet — 1 × ' + esc(meas(m().fitted)) + ' · ' + esc(state.depth.replace('Up to ', 'depth ')) + '</span><span>' + money(px('fitted', m().fitted, false, state.depth)) + '</span></div>';
    if (state.flat.active && state.flat.size) linen += '<div class="tac-sum__line"><span>Flat Sheet — 1 × ' + esc(meas(state.flat.size)) + '</span><span>' + money(px('flat', state.flat.size, true)) + '</span></div>';
    linen += '<div class="tac-sum__line"><span>Duvet Cover — 1 × ' + esc(meas(state.duvet.size)) + '</span><span>' + money(px('duvet', state.duvet.size, true)) + '</span></div>';
    g += '<div class="tac-sum__group"><div class="tac-sum__gk">Bed Linen</div>' + linen + '</div>';
    // Pillow shams: sleeping, personalized (Included), square
    var shams = '';
    state.sleeping.lines.forEach(function (l) {
      shams += '<div class="tac-sum__line"><span>Sleeping — ' + l.qty + ' × ' + esc(meas(l.size)) + '</span><span>' + money(px('rect', l.size, true) * l.qty) + '</span></div>';
    });
    var pmeta = pv.ok && !pv.omit ? ' · “' + esc(pv.text) + '”' : '';
    shams += '<div class="tac-sum__line"><span>Personalized — 1 × ' + esc(meas(m().sham)) + pmeta + '</span><span>Included</span></div>';
    state.square.lines.forEach(function (l) {
      shams += '<div class="tac-sum__line"><span>Square — ' + l.qty + ' × ' + esc(meas(l.size)) + '</span><span>' + money(px('square', l.size, true) * l.qty) + '</span></div>';
    });
    g += '<div class="tac-sum__group"><div class="tac-sum__gk">Pillow Shams</div>' + shams + '</div>';
    var pieces = K.pieceCount(state);
    g += '<div class="tac-sum__foot"><span class="tac-sum__pieces">' + pieces + ' piece' + (pieces === 1 ? '' : 's') + '</span><span class="tac-sum__total">' + money(sumTotal()) + '</span></div>';
    elSummary.innerHTML = g;
    var gate = K.canAddToCart(state, byId);
    elAtc.disabled = !gate.ok;
    elEmpty.hidden = gate.ok;
    elLead.textContent = 'Made to order in Tuscany · Please allow ' + CTX.leadTime + '.';
  }

  function sumTotal() {
    return K.lines(state).reduce(function (s, it) {
      return s + px(it.component, it.size, it.tiered, it.depth) * it.qty;
    }, 0);
  }

  function render() {
    var prev = document.getElementById('tac-perso');
    var caret = (prev && document.activeElement === prev) ? { s: prev.selectionStart, e: prev.selectionEnd } : null;
    renderFabric(); renderRows(); renderSummary();
    if (caret) { var pf = document.getElementById('tac-perso'); if (pf) { pf.focus(); try { pf.setSelectionRange(caret.s, caret.e); } catch (e) {} } }
  }

  // ---- events ----
  root.addEventListener('click', function (e) {
    var t = e.target.closest('button'); if (!t) return;
    if (t.hasAttribute('data-fab')) return dispatch({ type: 'fabric', fabric: t.getAttribute('data-fab') });
    if (t.hasAttribute('data-toggle')) { var k = t.getAttribute('data-toggle'); if (k === 'flat' && !state.flat.active) { dispatch({ type: 'flat.enable' }); ui.flat = true; return render(); } if (k === 'square' && !state.square.lines.length) { dispatch({ type: 'square.add' }); ui.square = true; return render(); } ui[k] = !ui[k]; return render(); }
    if (t.hasAttribute('data-mattress')) return dispatch({ type: 'mattress', mattress: t.getAttribute('data-mattress') });
    if (t.hasAttribute('data-depth')) return dispatch({ type: 'depth', depth: t.getAttribute('data-depth') });
    if (t.hasAttribute('data-sleeping-size')) { var le = t.closest('[data-line]'); return dispatch({ type: 'sleeping.size', index: le ? +le.getAttribute('data-line') : 0, size: t.getAttribute('data-sleeping-size') }); }
    if (t.hasAttribute('data-sleeping-add')) return dispatch({ type: 'sleeping.add' });
    if (t.hasAttribute('data-sleeping-remove')) return dispatch({ type: 'sleeping.remove', index: +t.getAttribute('data-sleeping-remove') });
    if (t.hasAttribute('data-flat-size')) return dispatch({ type: 'flat.size', size: t.getAttribute('data-flat-size') });
    if (t.hasAttribute('data-flat-apply')) return dispatch({ type: 'flat.apply' });
    if (t.hasAttribute('data-flat-remove')) { ui.flat = false; return dispatch({ type: 'flat.remove' }); }
    if (t.hasAttribute('data-duvet-size')) return dispatch({ type: 'duvet.size', size: t.getAttribute('data-duvet-size') });
    if (t.hasAttribute('data-duvet-apply')) return dispatch({ type: 'duvet.apply' });
    if (t.hasAttribute('data-square-size')) { var le2 = t.closest('[data-line]'); return dispatch({ type: 'square.size', index: le2 ? +le2.getAttribute('data-line') : 0, size: t.getAttribute('data-square-size') }); }
    if (t.hasAttribute('data-square-remove')) return dispatch({ type: 'square.remove', index: +t.getAttribute('data-square-remove') });
    var qc = t.closest('[data-qty]');
    if (qc) {
      var qkey = qc.getAttribute('data-qty'), dir = +t.getAttribute('data-dir');
      if (qkey.indexOf('sleeping:') === 0) { var si = +qkey.split(':')[1]; return dispatch({ type: 'sleeping.qty', index: si, qty: state.sleeping.lines[si].qty + dir }); }
      if (qkey.indexOf('square:') === 0) { var qi = +qkey.split(':')[1]; return dispatch({ type: 'square.qty', index: qi, qty: state.square.lines[qi].qty + dir }); }
      return;
    }
    if (t === elAtc || t.closest('[data-tac-atc]')) return addToCart();
  });

  root.addEventListener('input', function (e) {
    var el = e.target.closest('[data-perso]'); if (!el) return;
    state = K.reduce(state, { type: 'personalization', value: el.value });
    render();
  });

  function addToCart() {
    if (!K.canAddToCart(state, byId).ok) return;
    elAtc.disabled = true; var old = elAtcLabel.textContent; elAtcLabel.textContent = 'Adding…';
    var restore = function () { elAtcLabel.textContent = old; elAtc.disabled = false; };
    var ctx = Object.assign({ fabricLabel: fabricLabel() }, CTX);
    var items;
    try { items = K.cartItems(state, byId, ctx); }
    catch (err) { restore(); return; }
    Core.addBundle(items).then(function () { restore(); }).catch(function () { restore(); });
  }

  // ---- Bed Size dropdown controller (delegated; survives full re-renders).
  // Drives the SAME mattress reducer as the original option buttons — pure UI. ----
  function msEls() { return { wrap: root.querySelector('[data-tac-mselect]'), toggle: root.querySelector('[data-mselect-toggle]'), panel: root.querySelector('[data-mselect-panel]') }; }
  function msIsOpen() { var e = msEls(); return !!(e.panel && !e.panel.hidden); }
  function msOpts() { var e = msEls(); return e.panel ? Array.prototype.slice.call(e.panel.querySelectorAll('[data-mselect-opt]')) : []; }
  function msActivate(opt) { msOpts().forEach(function (o) { o.tabIndex = -1; }); if (opt) opt.tabIndex = 0; }
  function msOpen() {
    var e = msEls(); if (!e.toggle || !e.panel) return;
    e.panel.hidden = false; e.toggle.setAttribute('aria-expanded', 'true');
    var sel = e.panel.querySelector('[data-mselect-opt][aria-selected="true"]') || e.panel.querySelector('[data-mselect-opt]');
    if (sel) { msActivate(sel); sel.focus(); }
  }
  function msClose(focusToggle) {
    var e = msEls(); if (!e.toggle || !e.panel) return;
    e.panel.hidden = true; e.toggle.setAttribute('aria-expanded', 'false');
    if (focusToggle && e.toggle) e.toggle.focus();
  }
  function msSelect(k) { msClose(false); dispatch({ type: 'mattress', mattress: k }); var e = msEls(); if (e.toggle) e.toggle.focus(); }
  root.addEventListener('click', function (e) {
    var tog = e.target.closest('[data-mselect-toggle]');
    if (tog) { e.preventDefault(); if (msIsOpen()) msClose(true); else msOpen(); return; }
    var opt = e.target.closest('[data-mselect-opt]');
    if (opt) { e.preventDefault(); msSelect(opt.getAttribute('data-mselect-opt')); return; }
  });
  root.addEventListener('keydown', function (e) {
    var opt = e.target.closest('[data-mselect-opt]');
    var tog = e.target.closest('[data-mselect-toggle]');
    if (tog && !opt) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); if (msIsOpen()) msClose(true); else msOpen(); }
      else if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Down' || e.key === 'Up') { e.preventDefault(); if (!msIsOpen()) msOpen(); }
      else if (e.key === 'Escape' || e.key === 'Esc') { if (msIsOpen()) { e.preventDefault(); msClose(true); } }
      return;
    }
    if (opt) {
      var opts = msOpts(), i = opts.indexOf(opt), n;
      if (e.key === 'ArrowDown' || e.key === 'Down') { e.preventDefault(); n = opts[Math.min(opts.length - 1, i + 1)]; if (n) { msActivate(n); n.focus(); } }
      else if (e.key === 'ArrowUp' || e.key === 'Up') { e.preventDefault(); n = opts[Math.max(0, i - 1)]; if (n) { msActivate(n); n.focus(); } }
      else if (e.key === 'Home') { e.preventDefault(); n = opts[0]; if (n) { msActivate(n); n.focus(); } }
      else if (e.key === 'End') { e.preventDefault(); n = opts[opts.length - 1]; if (n) { msActivate(n); n.focus(); } }
      else if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); msSelect(opt.getAttribute('data-mselect-opt')); }
      else if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); msClose(true); }
      else if (e.key === 'Tab') { msClose(false); }
    }
  });
  document.addEventListener('click', function (e) {
    if (!msIsOpen()) return;
    if (e.target.closest('[data-tac-mselect]')) return;
    msClose(false);
  });

  render();
})();
